
// import store from "../redux/store";

export function get() {
  // let getToken = store.getState();
  return localStorage.getItem("accessToken");
}
export function tokenexist() {
  return !localStorage.getItem("accessToken");
}

//const apiUrl = process.env.REACT_APP_TOKEN_ISSUER;
// const apiUrl = "";
// const _BASE_URL = `${apiUrl}`;
// const iss = {
//   iss: _BASE_URL,
// };

function isLoginValid() {
  const access_Token = get();
  if (access_Token) {
    return true;
  }
  return false;
}

export function loggedIn() {
  return isLoginValid();
}
